<!--定时红包 倒计时挂件 -->
<template>
  <div v-if="delayTimeSecond > 0" class="c-classroom-rp-delay" @click="handleClick">
    <img
      v-if="tabType.rain === selfRedpackType"
      class="c-classroom-rp-delay-img"
      src="./images/rp-rain-delay.png"
      alt=""
    />
    <img
      v-else-if="tabType.password === selfRedpackType"
      class="c-classroom-rp-delay-img"
      src="./images/rp-password-delay.png"
      alt=""
    />
    <img
      v-else
      class="c-classroom-rp-delay-img"
      src="./images/rp-normal-delay.png"
      alt=""
    />
    <div class="c-classroom-rp-delay-time">
      {{ calcDelay.min }}:{{ calcDelay.second }}
    </div>
  </div>
</template>

<script>
import redpacketDelay from '../../mixins/redpacket-delay';
export default {
  name: 'RedpacketCountdown',
  mixins: [redpacketDelay],
  mounted() {
    this.core.on('onHandleRedpacketDelayStart', ({ delayTime, redpackType }) => {
      this.delayTimeSecond = delayTime;
      this.selfRedpackType = redpackType;
      this.initTimer();
    });
  },
  methods: {
    handleClick() {
      // 即将废弃
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('handleClick', { delayTime: this.delayTimeSecond, redpackType: this.selfRedpackType }); // 点击,发送剩余倒计时
      // 推荐使用
      this.$emit('handle-click', { delayTime: this.delayTimeSecond, redpackType: this.selfRedpackType }); // 点击,发送剩余倒计时
    },
  }
};
</script>

<style lang="scss" scoped>
.c-classroom-rp-delay {
  text-align: center;
  .c-classroom-rp-delay-img {
    width: 56px;
    height: 56px;
  }
  .c-classroom-rp-delay-time {
    padding-left: 4px;
    font-size: 12px;
    color: #ffffffcc;
  }
}
</style>
